import { Check } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'

import classes, { ICON_SIZE } from './index.styles'

/** 
 The checkmark will start small, rotated, off-screen, and green with no background. When isVisible becomes true, it will animate to the center of the screen, grow to ICON_SIZE, rotate to 0 degrees, and change to white on a green circle.
 */
const AnimatedCheck = ({ isVisible }: { isVisible: boolean }) => {
  const theme = useTheme()

  return (
    <Box
      data-testid={isVisible ? 'animated-check-visible' : 'animated-check-hidden'}
      sx={{
        ...classes.container,
        opacity: isVisible ? 1 : 0,
        rotate: isVisible ? '0deg' : '80deg',
        transform: isVisible ? 'translate(0, 0)' : 'translate(100px, -200px)',
        fontSize: isVisible ? ICON_SIZE : '20px',
        transition: theme.transitions.create(['rotate', 'transform', 'font-size'], {
          duration: 1000,
          easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)', // Creates a small bounce effect at the end of the animation
        }),
      }}
    >
      <Box
        sx={{
          ...classes.iconContainer,
          backgroundColor: isVisible ? theme.palette.success.variant1 : 'transparent',
          transition: theme.transitions.create('background-color', { delay: 1000 }),
        }}
      >
        <Check
          sx={{
            ...classes.icon,
            fontSize: 'inherit',
            color: isVisible ? theme.palette.common.white : theme.palette.success.variant1,
            transition: theme.transitions.create('color', { delay: 1000 }),
          }}
        />
      </Box>
    </Box>
  )
}

export default AnimatedCheck
